export default "__VITE_ASSET__b1dffaee__"